var map = {
	"./assets/svg/a-lock.svg": 482,
	"./assets/svg/a-person.svg": 483,
	"./assets/svg/add-new.svg": 484,
	"./assets/svg/add.svg": 485,
	"./assets/svg/addresses_neon.svg": 486,
	"./assets/svg/addresses_neon_old.svg": 487,
	"./assets/svg/arrow-right-round.svg": 488,
	"./assets/svg/back-round-inverted.svg": 489,
	"./assets/svg/back-round.svg": 490,
	"./assets/svg/back.svg": 491,
	"./assets/svg/basket-new.svg": 492,
	"./assets/svg/basket.svg": 493,
	"./assets/svg/bicycle-white.svg": 494,
	"./assets/svg/bicycle.svg": 495,
	"./assets/svg/bicycle_neon.svg": 496,
	"./assets/svg/burger-icon.svg": 497,
	"./assets/svg/cafe-icon.svg": 498,
	"./assets/svg/cart-shopping-fast.svg": 499,
	"./assets/svg/cart-shopping-fast_old.svg": 500,
	"./assets/svg/check.svg": 501,
	"./assets/svg/chevron-down.svg": 502,
	"./assets/svg/chevron-right.svg": 503,
	"./assets/svg/clock.svg": 504,
	"./assets/svg/close-inverted.svg": 505,
	"./assets/svg/close.svg": 506,
	"./assets/svg/compass.svg": 507,
	"./assets/svg/decrease.svg": 508,
	"./assets/svg/delivery.svg": 509,
	"./assets/svg/dots.svg": 510,
	"./assets/svg/down.svg": 511,
	"./assets/svg/fruit-icon.svg": 512,
	"./assets/svg/hamburger-menu.svg": 513,
	"./assets/svg/happiness-delivered-logo.svg": 514,
	"./assets/svg/home.svg": 515,
	"./assets/svg/home_solid.svg": 516,
	"./assets/svg/home_solid_neon.svg": 517,
	"./assets/svg/home_solid_purple.svg": 518,
	"./assets/svg/home_solid_white.svg": 519,
	"./assets/svg/icn-back-old.svg": 520,
	"./assets/svg/icn-back.svg": 521,
	"./assets/svg/increase.svg": 522,
	"./assets/svg/left.svg": 523,
	"./assets/svg/location.svg": 524,
	"./assets/svg/location_purple.svg": 525,
	"./assets/svg/location_white.svg": 526,
	"./assets/svg/lock.svg": 527,
	"./assets/svg/logo-small.svg": 528,
	"./assets/svg/logo.svg": 529,
	"./assets/svg/logout.svg": 530,
	"./assets/svg/meetings-icon.svg": 531,
	"./assets/svg/next.svg": 532,
	"./assets/svg/pickup.svg": 533,
	"./assets/svg/pin-desktop.svg": 534,
	"./assets/svg/pin.svg": 535,
	"./assets/svg/receipt.svg": 536,
	"./assets/svg/right.svg": 537,
	"./assets/svg/seafood-icon.svg": 538,
	"./assets/svg/sidebar-about-icon.svg": 539,
	"./assets/svg/sidebar-happy-lunch-icon.svg": 540,
	"./assets/svg/sidebar-orders-icon.svg": 541,
	"./assets/svg/sidebar-takeaway-icon.svg": 542,
	"./assets/svg/spicy.svg": 543,
	"./assets/svg/store.svg": 544,
	"./assets/svg/store_old.svg": 545,
	"./assets/svg/success.svg": 546,
	"./assets/svg/times-new.svg": 547,
	"./assets/svg/trash.svg": 548,
	"./assets/svg/tribe-logo-khaki.svg": 549,
	"./assets/svg/tribe-logo-text-black-old.svg": 550,
	"./assets/svg/tribe-logo-text-black.svg": 551,
	"./assets/svg/user-circle-white.svg": 552,
	"./assets/svg/user-circle.svg": 553,
	"./assets/svg/user-desktop.svg": 554,
	"./assets/svg/user.svg": 555,
	"./assets/svg/user_old.svg": 556,
	"./assets/svg/vegan.svg": 557,
	"./assets/svg/vegetarian.svg": 558,
	"./assets/svg/walking-white.svg": 559,
	"./assets/svg/walking.svg": 560,
	"./dist/svg/addresses.svg": 561,
	"./dist/svg/addresses_old.svg": 562,
	"./dist/svg/apple-pay.svg": 563,
	"./dist/svg/arrow-left.svg": 564,
	"./dist/svg/arrow-right-long.svg": 565,
	"./dist/svg/arrow-right.svg": 566,
	"./dist/svg/bicycle-new-green.svg": 567,
	"./dist/svg/bicycle-new.svg": 568,
	"./dist/svg/bicycle.svg": 569,
	"./dist/svg/bowl-rice.svg": 570,
	"./dist/svg/bowl-rice_old.svg": 571,
	"./dist/svg/button-swiper-left.svg": 572,
	"./dist/svg/button-swiper-right.svg": 573,
	"./dist/svg/cafe-icon.svg": 574,
	"./dist/svg/chevron-right.svg": 575,
	"./dist/svg/circle-xmark.svg": 576,
	"./dist/svg/comment.svg": 577,
	"./dist/svg/comment_old.svg": 578,
	"./dist/svg/corporate-account-icon.svg": 579,
	"./dist/svg/corporate.svg": 580,
	"./dist/svg/corporate_2.svg": 581,
	"./dist/svg/coupon.svg": 582,
	"./dist/svg/coupon_old.svg": 583,
	"./dist/svg/delivery-neon.svg": 584,
	"./dist/svg/delivery-toggle-divider-rotated.svg": 585,
	"./dist/svg/delivery-toggle-divider.svg": 586,
	"./dist/svg/delivery.svg": 587,
	"./dist/svg/denied.svg": 588,
	"./dist/svg/envelope.svg": 589,
	"./dist/svg/envelope_old.svg": 590,
	"./dist/svg/fruit-icon-2.svg": 591,
	"./dist/svg/fruit-icon.svg": 592,
	"./dist/svg/happiness-delivered-logo.svg": 593,
	"./dist/svg/hexagon-rice-2.svg": 594,
	"./dist/svg/hexagon-rice.svg": 595,
	"./dist/svg/hexagon-scooter.svg": 596,
	"./dist/svg/how-it-works-logo.svg": 597,
	"./dist/svg/loader.svg": 598,
	"./dist/svg/location-arrow-down.svg": 599,
	"./dist/svg/location-arrow-right.svg": 600,
	"./dist/svg/lock-icon.svg": 601,
	"./dist/svg/logout.svg": 602,
	"./dist/svg/logout_old.svg": 603,
	"./dist/svg/map-marker.svg": 604,
	"./dist/svg/map-marker_old.svg": 605,
	"./dist/svg/map-marker_oldold.svg": 606,
	"./dist/svg/mastercard.svg": 607,
	"./dist/svg/meetings-icon-2.svg": 608,
	"./dist/svg/minus.svg": 609,
	"./dist/svg/moments-icon.svg": 610,
	"./dist/svg/payment.svg": 611,
	"./dist/svg/payment_old.svg": 612,
	"./dist/svg/pickup-neon.svg": 613,
	"./dist/svg/pickup.svg": 614,
	"./dist/svg/plus-icon-green.svg": 615,
	"./dist/svg/plus-icon.svg": 616,
	"./dist/svg/plus.svg": 617,
	"./dist/svg/promo-icon.svg": 618,
	"./dist/svg/refunded.svg": 619,
	"./dist/svg/rice-bowls-plus-one.svg": 620,
	"./dist/svg/rice-bowls.svg": 621,
	"./dist/svg/right-arrow-long.svg": 622,
	"./dist/svg/shopping-bag-neon.svg": 623,
	"./dist/svg/shopping-bag.svg": 624,
	"./dist/svg/shopping-bag_old.svg": 625,
	"./dist/svg/splash/1.svg": 626,
	"./dist/svg/splash/2.svg": 627,
	"./dist/svg/splash/3.svg": 628,
	"./dist/svg/splash/4.svg": 629,
	"./dist/svg/splash/5.svg": 630,
	"./dist/svg/support.svg": 631,
	"./dist/svg/support_old.svg": 632,
	"./dist/svg/terms.svg": 633,
	"./dist/svg/terms_old.svg": 634,
	"./dist/svg/times-new.svg": 635,
	"./dist/svg/trash.svg": 636,
	"./dist/svg/tribe-logo-black.svg": 637,
	"./dist/svg/tribe-logo-letters.svg": 638,
	"./dist/svg/tribe-logo-symbol.svg": 639,
	"./dist/svg/user.svg": 640,
	"./dist/svg/user2.svg": 641,
	"./dist/svg/user_old.svg": 642,
	"./dist/svg/visa.svg": 643,
	"./dist/svg/walking-new-green.svg": 644,
	"./dist/svg/walking-new.svg": 645,
	"./dist/svg/wallet.svg": 646,
	"./dist/svg/xmark.svg": 647,
	"./dist/svg/xmark_white.svg": 648,
	"./static/suppliers/michael-h-konditoriet/images/logo.svg": 649,
	"./static/svg/addresses.svg": 650,
	"./static/svg/addresses_old.svg": 651,
	"./static/svg/apple-pay.svg": 652,
	"./static/svg/arrow-left.svg": 653,
	"./static/svg/arrow-right-long.svg": 654,
	"./static/svg/arrow-right.svg": 655,
	"./static/svg/bicycle-new-green.svg": 656,
	"./static/svg/bicycle-new.svg": 657,
	"./static/svg/bicycle.svg": 658,
	"./static/svg/bowl-rice.svg": 659,
	"./static/svg/bowl-rice_old.svg": 660,
	"./static/svg/button-swiper-left.svg": 661,
	"./static/svg/button-swiper-right.svg": 662,
	"./static/svg/cafe-icon.svg": 663,
	"./static/svg/chevron-down-solid.svg": 664,
	"./static/svg/chevron-right.svg": 665,
	"./static/svg/circle-xmark.svg": 666,
	"./static/svg/comment.svg": 667,
	"./static/svg/comment_old.svg": 668,
	"./static/svg/corporate-account-icon.svg": 669,
	"./static/svg/corporate.svg": 670,
	"./static/svg/corporate_2.svg": 671,
	"./static/svg/coupon.svg": 672,
	"./static/svg/coupon_old.svg": 673,
	"./static/svg/delivery-neon.svg": 674,
	"./static/svg/delivery-toggle-divider-rotated.svg": 675,
	"./static/svg/delivery-toggle-divider.svg": 676,
	"./static/svg/delivery.svg": 677,
	"./static/svg/denied.svg": 678,
	"./static/svg/envelope.svg": 679,
	"./static/svg/envelope_old.svg": 680,
	"./static/svg/fa/circle-info-solid.svg": 681,
	"./static/svg/fa/clock-solid.svg": 682,
	"./static/svg/fa/location-dot-solid.svg": 683,
	"./static/svg/fa/truck-solid.svg": 684,
	"./static/svg/fruit-icon-2.svg": 685,
	"./static/svg/fruit-icon.svg": 686,
	"./static/svg/happiness-delivered-logo.svg": 687,
	"./static/svg/hexagon-rice-2.svg": 688,
	"./static/svg/hexagon-rice.svg": 689,
	"./static/svg/hexagon-scooter.svg": 690,
	"./static/svg/how-it-works-logo.svg": 691,
	"./static/svg/loader.svg": 692,
	"./static/svg/location-arrow-down.svg": 693,
	"./static/svg/location-arrow-right.svg": 694,
	"./static/svg/lock-icon.svg": 695,
	"./static/svg/logout.svg": 696,
	"./static/svg/logout_old.svg": 697,
	"./static/svg/map-marker.svg": 698,
	"./static/svg/map-marker_old.svg": 699,
	"./static/svg/map-marker_oldold.svg": 700,
	"./static/svg/mastercard.svg": 701,
	"./static/svg/meetings-icon-2.svg": 702,
	"./static/svg/minus.svg": 703,
	"./static/svg/moments-icon.svg": 704,
	"./static/svg/payment.svg": 705,
	"./static/svg/payment_old.svg": 706,
	"./static/svg/phone.svg": 707,
	"./static/svg/pickup-neon.svg": 708,
	"./static/svg/pickup.svg": 709,
	"./static/svg/plus-icon-green.svg": 710,
	"./static/svg/plus-icon.svg": 711,
	"./static/svg/plus.svg": 712,
	"./static/svg/promo-icon.svg": 713,
	"./static/svg/refunded.svg": 714,
	"./static/svg/rice-bowls-plus-one.svg": 715,
	"./static/svg/rice-bowls.svg": 716,
	"./static/svg/right-arrow-long-green.svg": 717,
	"./static/svg/right-arrow-long.svg": 718,
	"./static/svg/shopping-bag-neon.svg": 719,
	"./static/svg/shopping-bag.svg": 720,
	"./static/svg/shopping-bag_old.svg": 721,
	"./static/svg/sidebar-takeaway-icon.svg": 722,
	"./static/svg/splash/1.svg": 723,
	"./static/svg/splash/2.svg": 724,
	"./static/svg/splash/3.svg": 725,
	"./static/svg/splash/4.svg": 726,
	"./static/svg/splash/5.svg": 727,
	"./static/svg/support.svg": 728,
	"./static/svg/support_old.svg": 729,
	"./static/svg/terms.svg": 730,
	"./static/svg/terms_old.svg": 731,
	"./static/svg/times-new.svg": 732,
	"./static/svg/trash.svg": 733,
	"./static/svg/tribe-logo-black.svg": 734,
	"./static/svg/tribe-logo-letters.svg": 735,
	"./static/svg/tribe-logo-symbol.svg": 736,
	"./static/svg/tribe-logo-white.svg": 737,
	"./static/svg/truck.svg": 738,
	"./static/svg/user.svg": 739,
	"./static/svg/user2.svg": 740,
	"./static/svg/user_old.svg": 741,
	"./static/svg/visa.svg": 742,
	"./static/svg/walking-new-green.svg": 743,
	"./static/svg/walking-new.svg": 744,
	"./static/svg/wallet.svg": 745,
	"./static/svg/xmark.svg": 746,
	"./static/svg/xmark_white.svg": 747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;